/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/content/themes/wrike/dist/js/projects/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 457);
/******/ })
/************************************************************************/
/******/ ({

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WG = window.WG;

exports.default = WG;

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _wg = __webpack_require__(34);

var _wg2 = _interopRequireDefault(_wg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toggleHistory(event) {
    var $list = $('.history__list');
    var $button = $(event.target);
    var classOpened = 'history__list--opened';
    var textLess = $button.data('less');
    var textMore = $button.data('more');
    var isOpened = $list.hasClass(classOpened);

    if (isOpened) {
        $list.removeClass(classOpened);
        $button.text(textMore);
    } else {
        $list.addClass(classOpened);
        $button.text(textLess);
    }
}

function initHistoryToggler() {
    $('.history__button').on('click', toggleHistory);
}

function playVideo() {
    var $videoElem = $('.video');
    var youtubeId = $videoElem.data('youtube-id');
    var htmlIframe = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + youtubeId + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
    var isIframeAppended = false;

    if (!$videoElem.length) {
        return false;
    }

    $videoElem.on('click', function () {
        if (isIframeAppended === false) {
            _wg2.default.GdprUserCentrics.makeConditionalCallback(function () {
                $videoElem.addClass('playing');
                $videoElem.append(htmlIframe);
                isIframeAppended = true;
            }, _wg2.default.GdprUserCentrics.ConsentCategories.Advertising)();
        }
    });
}

function main() {
    initHistoryToggler();
    playVideo();
}

$(main);

/***/ })

/******/ });


// WEBPACK FOOTER //
// company/company.js